import { request as http } from '@/utils/http'
import type {
  ApiResponse,
  SalesQueryContext,
  PageResponse,
  PriceFclPageRequest,
  PriceFclListVO,
  PriceFclVO
} from './types'

// 分页查询整箱运价列表
export const page = (params: PriceFclPageRequest) => {
  return http.post<PageResponse<PriceFclListVO>>('/price/query/fcl/page', params)
}

// 获取整箱运价详情
export const get = (id: string, context: SalesQueryContext = {}) => {
  return http.post<PriceFclVO>('/price/query/fcl/get', { ...context, id })
}

